
const digest = '73a16a9cc0da1b596baabf61cba1e42f764151715d732159766084483cefb46d';
const classes = {"wrapper":"_wrapper_1ut1u_1","buttonWrapper":"_buttonWrapper_1ut1u_7","button":"_button_1ut1u_7"};
const css = `._wrapper_1ut1u_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_1ut1u_1 ._buttonWrapper_1ut1u_7 {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
._wrapper_1ut1u_1 ._buttonWrapper_1ut1u_7 ._button_1ut1u_7 {
  width: fit-content;
  min-width: 100px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  